export const getWidgetChannelInfo = (widget_tab) => {
  const parts = widget_tab?.split('.') || []

  // Special case
  if (widget_tab === 'trueengage.callback.schedule' || widget_tab === 'trueengage.callback.schedule-pre-interaction-form') {
    return { channel: 'schedule', view: null }
  }

  const [, channel = null, view = null] = parts

  return { channel, view }
}
